import { jwtDecode } from 'jwt-decode';
import api from '../../utils/webcall';
import { ACCESS_TOKEN, REFRESH_TOKEN } from '../../utils/token';
import * as responseCache from '../../utils/responseCache';

var UserProfile = (function () {
    // var username = "username";
    var userdata = 'userdata';
    // var auth_key = "cur_user_auth";
    var isAuthorized = 'is_authorized'

    var setIsAuthorized = (flag) => {
        window.sessionStorage.setItem(isAuthorized, flag);
    }

    // var userDetailsAvailable = () => {
    //     return isLoggedIn() && (window.sessionStorage.get(userdata) != undefined || window.sessionStorage.get(userdata) != null)
    // }

    var auth = async () => {
        try {
            const token = window.sessionStorage.getItem(ACCESS_TOKEN);
            if (token) {
                const decoded = jwtDecode(token);
                const tokenExpiration = decoded.exp;
                const now = Date.now() / 1000;

                if (tokenExpiration < now) {
                    return await refreshToken();
                } else {
                    setIsAuthorized(true);
                    return true;
                }
            }
            else {
                setIsAuthorized(false);
                return false;
            }
        }
        catch (error) {
            console.error('Auth error:', error);
            setIsAuthorized(false);
            return false;
        }
    };

    var refreshToken = async () => {
        const refreshToken = window.sessionStorage.getItem(REFRESH_TOKEN);
        if (!refreshToken) {
            setIsAuthorized(false);
            return false;
        }

        try {
            const res = await api.post('/auth/token/refresh/', {
                refresh: refreshToken,
            });
            if (res.status === 200) {
                window.sessionStorage.setItem(ACCESS_TOKEN, res.data.access);
                setIsAuthorized(true);
                return true;
            } else {
                setIsAuthorized(false);
                return false;
            }
        } catch (error) {
            console.error('Error refreshing token:', error);
            setIsAuthorized(false);
            return false;
        }
    };

    const logout = () => {
        window.sessionStorage.removeItem(ACCESS_TOKEN);
        window.sessionStorage.removeItem(userdata);
        setIsAuthorized(false);
        // Forget that a session was ever verified. The reload below clears this
        // module anyway today, but a cached "verified half a minute ago" that
        // outlived a sign-out would let the next person in without a check.
        lastVerifiedAt = 0;
        verifyInFlight = null;
        // One account's figures must never be the first thing the next one
        // sees. The reload below clears this too today, but the cache is not
        // this module's to assume about.
        responseCache.clear();
        window.location.reload();
    };
    
    var getName = function () {
        if(isLoggedIn()){
            let temp = JSON.parse(window.sessionStorage.getItem(userdata));
            if(temp === null) return "";
            return JSON.parse(window.sessionStorage.getItem(userdata))["first_name"];
        }
        return "";
        
    };

    // var setName = function (name) {
    //     let newname = _.camelCase(name);
    //     window.sessionStorage.setItem(username, newname);
    // };

    var setAuth = function(token, refresh){
        window.sessionStorage.setItem(ACCESS_TOKEN, token);
        window.sessionStorage.setItem(REFRESH_TOKEN, refresh);
    }

    var setUserData = function(data){
        window.sessionStorage.setItem(userdata, JSON.stringify(data));
    }

    var isLoggedIn = function(){
        let temp = window.sessionStorage.getItem(ACCESS_TOKEN);
        return !(temp === null || temp === undefined);
    }

    var getRole = function(){
        if(!isLoggedIn()){
            return '';
        }
        let temp = JSON.parse(window.sessionStorage.getItem(userdata));
        if(temp === null){
            return ''
        }
        temp = temp['role'];
        return (temp !== null && temp !== undefined) ? temp.toUpperCase() : '';
    }

    // The server sends `is_owner` and `is_manager` alongside the role, because
    // it is the server that decides. These read that answer where it is
    // present, and fall back to the role only for a session that signed in
    // before the field existed.
    var capability = function (field, fallback) {
        if (!isLoggedIn()) return false;
        let data = JSON.parse(window.sessionStorage.getItem(userdata));
        if (data === null) return false;
        if (typeof data[field] === 'boolean') return data[field];
        return fallback();
    }

    /**
     * Owners run the business. Only they see takings, margins and what people
     * are paid, and only they approve leave and advances.
     */
    var isOwner = function () {
        return capability('is_owner',
            () => getRole() === "OWNER" || getRole() === "SUPERUSER");
    }

    var isManager = function(){
        return capability('is_manager',
            () => ["MANAGER", "OWNER", "SUPERUSER"].includes(getRole()));
    }

    /**
     * When the last successful check finished, and the check in flight.
     *
     * Both exist to stop the same round trip being made over and over. Every
     * page is wrapped in an AccessController, which verifies on mount - so
     * before this, moving between pages spent a full browser-to-server round
     * trip on re-asking a question answered seconds earlier, every single time,
     * while the page waited. That is the slowest thing a navigation did.
     */
    let lastVerifiedAt = 0;
    let verifyInFlight = null;

    // How long a successful check stands for. Deliberately far shorter than the
    // five-minute interval AccessController already re-checks on, so this can
    // only ever reduce the gap between checks, never widen it.
    //
    // Safe to cache at all because this check is convenience rather than
    // security, which AccessController's own docstring says plainly: it stops
    // somebody wandering into a page that will only show them errors. Every
    // endpoint behind every page enforces the same rule itself on every
    // request, because a client can be told anything. A revoked account is
    // refused by the API at once whatever this says.
    const VERIFY_GOOD_FOR_MS = 60 * 1000;

    var verifySession = async () => {
        if (!isLoggedIn()) {
            return false;
        }

        // Checked recently enough. The API is still the thing enforcing this.
        if (Date.now() - lastVerifiedAt < VERIFY_GOOD_FOR_MS) {
            return true;
        }
        // Already asking. Two pages mounting together - a page and the layout
        // around it - would otherwise each start their own round trip and race
        // to write the same answer.
        if (verifyInFlight) {
            return verifyInFlight;
        }

        verifyInFlight = runVerify().finally(() => { verifyInFlight = null; });
        return verifyInFlight;
    };

    var runVerify = async () => {
        try {
            // First check token validity
            if (!(await auth())) {
                return false;
            }

            // Then verify session with backend
            const response = await api.get('/auth/verify-session/');
            if (response.status !== 200) return false;

            // Refresh what this account is allowed to do while we are here.
            // Without this, someone made an owner - or no longer one - would
            // keep the old menu until they signed out and back in.
            const fresh = response.data?.user;
            if (fresh) {
                const stored = JSON.parse(
                    window.sessionStorage.getItem(userdata) || '{}');
                // Merged, not replaced: this response carries the capabilities
                // but not the person's name.
                setUserData({ ...stored, ...fresh });
            }
            // Only on success. A failed check must not count as an answer, or a
            // network blip would hold the door open for the next minute.
            lastVerifiedAt = Date.now();
            return true;
        } catch (error) {
            console.error('Session verification error:', error);
            return false;
        }
    };

    return {
        getName: getName,
        setAuth: setAuth,
        setUserData: setUserData,
        isLoggedIn: isLoggedIn,
        isManager: isManager,
        isOwner: isOwner,
        getRole: getRole,
        isAuthorized: isAuthorized,
        logout: logout,
        auth: auth,
        verifySession: verifySession
    }

})();

export default UserProfile;